/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from 'react';
import clsx from 'clsx';
import { Eyebrow, Heading, Types } from '@marriott/mi-ui-library';
import { PointsCard } from '@marriott/mi-cobrand-components';
import { useGetBreakpoint } from '../../utils/CommonUtils';
import { OffersMultiplierProps } from './OffersMultiplier.types';

export const OffersMultiplierWrapper: FC<OffersMultiplierProps> = props => {
  const { offersData } = props;
  const multiplierData = offersData?.responseObject?.offers?.[0]?.merchandisingOffer?.singleCard?.multiplier;
  const isMobileViewPort = useGetBreakpoint() === 'mobile';

  return (
    <div className="offermultiplier-container">
      <div className="offermultiplier-wrapper">
        <div className="multiplier-center">
          <Eyebrow text={multiplierData?.eyebrow} customClass={clsx('mb-2 text-center')} />
          <Heading
            titleText={multiplierData?.title}
            variation={Types.headingType.title}
            fontSize={Types.size.medium}
            customClass={'multiplier-title text-center mb-0'}
          />
          {multiplierData?.points?.length > 0 &&
            multiplierData?.points?.map((point: { text: string; description: string }) => {
              return (
                <div className="points-card-wrapper">
                  <PointsCard
                    isOnSpend={!isMobileViewPort}
                    number={point?.text}
                    content={point?.description}
                    variationType="default"
                    cardType=""
                    pointsForCarddetails={false}
                    styleClass="offers-pointscard"
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
